import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import loadStatus from "../../util/loadStatus";

const PaginationSecondBar = ({
  // currentPage = 1,
  // setPage = () => {},
  onPageChange = () => {},
  total = 10,
  loading,
}) => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setPage] = useState(1);
  const totalPages = Math.ceil(total / pageSize);

  const getPages = () => {
    const pages = [];
    const maxVisiblePages = 5;
    const sidePage = Math.floor((maxVisiblePages - 3) / 2);

    if (totalPages <= maxVisiblePages) {
      //Show all pages if total pages fit within the maxVisible
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      //Always show first and last page
      pages.push(1);

      let startPage = Math.max(currentPage - sidePage, 2);
      let endPage = Math.min(currentPage + sidePage, totalPages - 1);

      //Ensure at least  maxVisibleOages are shown
      if (currentPage - sidePage <= 1) {
        endPage = Math.min(maxVisiblePages - 2, totalPages - 1);
      }
      if (currentPage + sidePage >= totalPages) {
        startPage = Math.max(totalPages - maxVisiblePages + 2, 2);
      }

      //Add Elipses and middle pages
      if (startPage > 2) {
        pages.push("...");
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) {
        pages.push("...");
      }

      pages.push(totalPages);
    }
    return pages;
  };

  const pages = getPages();

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 border border-bkg2 rounded-md my-4 p-2 py-3 bg-bkg  overflow-auto">
      <div className="flex items-center gap-2">
        {/* Select size */}
        <select
          id="pageSize"
          value={pageSize}
          onChange={(e) => {
            setPageSize(parseInt(e.target.value, 10));
            onPageChange(e.target.value, 0);
            setPage(1);
          }}
          disabled={loading === loadStatus.loading || total === 0}
          className="block p-2 py-1 text-sm bg-bkg2/50 text-text-1 rounded-md shadow-sm focus:ring-primary hover:ring-primary focus:border-primary active:ring active:ring-primary"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
        {/* Total Division */}
        <div className="flex gap-1 text-text-1/75">
          <span>Total:</span> {total}
        </div>
      </div>

      {/* The divisions */}
      <div className="w-full sm:w-fit flex items-center justify-center space-x-1  overflow-auto">
        <button
          className="px-3 py-1 text-sm font-medium text-text-1/60 bg-bkg2/50 rounded-lg hover:bg-bkg2 disabled:opacity-50 disabled:cursor-not-allowed "
          disabled={currentPage === 1 || total === 0}
          onClick={() => {
            onPageChange(pageSize, (currentPage - 1 - 1) * pageSize);
            setPage(currentPage - 1);
          }}
        >
          <ChevronLeft size={20} />
        </button>

        {pages.map((page) => (
          <button
            key={page}
            //   className="px-3 py-1 text-sm font-medium text-text-1/60 bg-bkg2 rounded-lg hover:bg-bkg2 disabled:opacity-50 disabled:cursor-not-allowed"
            className={`px-3 py-1 text-sm font-medium rounded-lg  ${
              page === currentPage
                ? "bg-primary/80 text-white"
                : "text-text-1/60 bg-bkg2/50 hover:bg-bkg2"
            } `}
            onClick={() => {
              onPageChange(pageSize, (page - 1) * pageSize);
              setPage(page);
            }}
          >
            {page}
          </button>
        ))}

        <button
          className="px-3 py-1 text-sm font-medium text-text-1/60 bg-bkg2/50 rounded-lg hover:bg-bkg2 disabled:opacity-50 disabled:cursor-not-allowed "
          disabled={currentPage === totalPages || total === 0}
          onClick={() => {
            onPageChange(pageSize, (currentPage + 1 - 1) * pageSize);
            setPage(currentPage + 1);
          }}
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default PaginationSecondBar;
